import { render } from "./LxBg.vue?vue&type=template&id=1552aae6&scoped=true"
import script from "./LxBg.vue?vue&type=script&lang=js"
export * from "./LxBg.vue?vue&type=script&lang=js"

import "./LxBg.vue?vue&type=style&index=0&id=1552aae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1552aae6"]])

export default __exports__